import React, { useEffect, useState } from 'react';
// javascipt plugin for creating charts
import { Chart } from 'chart.js';
// react plugin used to create charts
import { Bar } from 'react-chartjs-2';
// reactstrap components
import { round } from 'lodash-es';
import { parseOptions } from 'variables/charts';
import { chartOptions } from 'variables/charts';
import { Card, CardBody, Spinner } from 'reactstrap';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { orderBy } from 'lodash';
import { useCorporateUserBasedAnalytics } from 'utils/queries/corporateAnalytics';
parseOptions(Chart, chartOptions());
Chart.plugins.register(ChartDataLabels);

export default function UserwiseAnalytics() {
  const {
    data: dailyData,
    isLoading,
    error,
  } = useCorporateUserBasedAnalytics();

  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    if (dailyData?.data?.length > 0) {
      const sortedData = orderBy(dailyData?.data, ['KWH_CONSUMED'], ['desc']);
      const data = {
        labels: sortedData?.map(
          (row, indx) => `${row?.NAME || row?.PHONE_NUMBER}`,
        ),
        datasets: [
          {
            label: '',
            data: sortedData?.map((row) => row?.KWH_CONSUMED),
            backgroundColor: '#9ac55d',
            color: '#ffffff',
            barThickness: 10,
            datalabels: {
              display: true,
              formatter: (value) => `${round(value, 2)} kWh`,
              color: 'black',
              anchor: 'end',
              offset: -20,
              align: 'start',
            },
          },
        ],
      };

      setChartData(data);
    }
  }, [dailyData]);

  if (isLoading) {
    <h1>Loading</h1>;
  }
  if (error) {
    <h1>Error</h1>;
  }

  const options = {
    title: {
      display: true,
      text: 'Userwise Energy Consumption',
      color: '#414141',
      position: 'bottom',
    },
    scales: {
      xAxes: {
        grid: {
          display: false,
        },
      },
      yAxes: [
        {
          ticks: {
            display: false,
          },
        },
      ],
    },
    layout: {
      padding: {
        top: 15,
        left: 0,
        right: 0,
        bottom: 0,
      },
    },
    tooltips: {
      enabled: false,
    },
  };
  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          border: '2px solid rgb(222, 222, 225)',
          borderRadius: '10px',
          boxShadow: 'rgb(222 222 225) 5px 5px',
        }}
      >
        {isLoading ? (
          <Spinner style={{ color: '#2675b8' }} />
        ) : error ? (
          'Oops something went wrong'
        ) : dailyData?.data?.lemgth === 0 ? (
          'We dont have any Analytics report'
        ) : (
          <Card style={{ width: '100%', height: '100%' }}>
            <CardBody>
              <div
                style={{
                  maxHeight: '250px',
                  minHeight: '250px',
                }}
              >
                {!chartData?.datasets?.data?.length === 0 ? (
                  <Bar options={options} data={chartData} />
                ) : (
                  <div
                    style={{
                      display: 'flex',
                      height: '250px',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    We dont have any Analytics report
                  </div>
                )}
              </div>
            </CardBody>
          </Card>
        )}
      </div>
    </>
  );
}
